"use client"

import { FishingHook } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FishingHookIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FishingHookIcon = component(Icon)({ as: FishingHook })
